// extracted by mini-css-extract-plugin
module.exports = {"FormVet":"FormVet_FormVet__37Ubr","mobile":"FormVet_mobile__waThK","Content":"FormVet_Content__9Q7xl","Title":"FormVet_Title__24M_j"};